module.exports = __webpack_public_path__ + "images/ico-add-lightgray.png?f186316a4b0b8598a049cac79f27ee2b";